/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SlimUserGenerationJob = {
  job_id: string;
  status?: SlimUserGenerationJob.status;
  readonly company_id?: number;
  readonly company_name?: string;
  readonly firm_id?: string;
  readonly firm_name?: string;
};
export namespace SlimUserGenerationJob {
  export enum status {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
  }
}

